import { COLLECTIONS } from "constants/action-types";
import { FluxStandardAction as Action } from "flux-standard-action";
import { IDeliveryPurchaseOrder } from "helpers/delivery-purchase-order";

export type MutateDeliveryPurchaseOrderAction = Action<
    {
        collectionId: string;
        deliveryPurchaseOrder: IDeliveryPurchaseOrder;
        index?: number;
    },
    | {
          history?: boolean;
      }
    | undefined
>;
export const mutateDeliveryPurchaseOrder = (
    collectionId: string,
    deliveryPurchaseOrder: IDeliveryPurchaseOrder,
    index?: number,
    meta?: any,
): MutateDeliveryPurchaseOrderAction => ({
    payload: {
        collectionId,
        deliveryPurchaseOrder,
        index,
    },
    meta,
    type: COLLECTIONS.COLLECTION.DELIVERY_PURCHASE_ORDER.MUTATE.START,
});

export type StartReconcilePOWithAllocationDimensionsAction = Action<{ collectionId: string }, undefined>;
export const startReconcilePOWithAllocationDimensions = (
    collectionId: string,
): StartReconcilePOWithAllocationDimensionsAction => ({
    payload: { collectionId },
    meta: undefined,
    type: COLLECTIONS.COLLECTION.DELIVERY_PURCHASE_ORDER.RECONCILE.START,
});
